import React, { Component, Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import LoggedContext from '../BusinessObjects/LoggedContext';
import { themeCol3, themeCol9, themeFormInput, themeGroup } from '../Utils/EsaedroTheme';

import { Button as Button_DevExtreme } from 'devextreme-react/button';
import { CustomEvents } from '../Utils/CustomEvents';


interface IEsaedroJSONComponentProps {
    component: any
    fieldName: string
    canEdit: boolean
    suggestedKeys?: string
    onChange?(event: any) : void
    children?: any
}

interface IEsaedroJSONComponentState {
  component: any
  componentFields: string[]
  newKeyLabel: string
  newKeyValue: string
  addingField: boolean
}

export default class EsaedroJSONComponent extends Component<IEsaedroJSONComponentProps,IEsaedroJSONComponentState> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  
  constructor(props: IEsaedroJSONComponentProps){
    super(props);

    this.state = {
      component: {},
      componentFields: [],
      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    };
  }

  componentDidMount(){
   
    // Già costruendo il component popolo le sue chiavi, ma controllo che sia effettivamente un JSON
    let isJson = this.isJSON(this.props.component)
    let jsonObject = isJson? JSON.parse(this.props.component) : this.props.component;
    let keys =  isJson? 
                  Object.keys(jsonObject)
                  : []

    // Controllo se ha già tutte le chiavi che dovrebbe avere, altrimenti le aggiungo
    if (this.props.suggestedKeys) {
      // Se non ha chiavi allora aggiungo le chiavi proposte
      if (keys.length == 0) {
        keys = this.props.suggestedKeys.split("|")
      }
    }

    this.setState({

      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    })
    if(keys !== undefined)
      this.setState({componentFields:keys});

    
    if((isJson && this.props.component>'')  || (!isJson && this.props.component !== undefined && this.props.component!== '')) 
      this.setState(  {component: jsonObject,});
  }

  // Controlla che l'oggetto sia effettivamente un JSON
  isJSON = (object: any) : boolean => {
    try {
      JSON.parse(object)
    }
    catch (e)
    {
      return false
    }
    return true
  }

  addKey = () => {
    // Aggiunge una chiave all'oggetto
    const {component, componentFields, newKeyLabel, newKeyValue} = this.state
    let newKeys = componentFields;
    let newComp = component

    newKeys.push(newKeyLabel)
   
    newComp[newKeyLabel] = newKeyValue

    this.setState({
      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    })

    if (this.props.onChange) {
      let customEvent = new CustomEvent(CustomEvents.JSONObjectChanged, {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(newComp)}})
      this.props.onChange(customEvent)
    }
  }

  toggleAddField = () => {
    this.setState({addingField: !this.state.addingField})
  }

  handleChange = (event: any) => {
    const target = event.target
    const {component, componentFields} = this.state

    if (target.name == "NewKey") {
      this.setState({newKeyLabel: target.value})
    }
    
    else if (target.name == "NewKeyValue") {
      this.setState({newKeyValue: target.value})
    }

    else {
      let value = target.value
      var key = target.name;

      if (componentFields.length > 0) {
        let tempObj = component;
        tempObj[key] = value;

        if (this.props.onChange) {
          let customEvent = new CustomEvent(CustomEvents.JSONObjectChanged, {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(tempObj)}})
          this.props.onChange(customEvent)
        }
      }
      else {
        let tempObj = component;
        tempObj = value;       
        
        if (this.props.onChange) {
          let customEvent = new CustomEvent(CustomEvents.JSONObjectChanged, {detail: {"name" : this.props.fieldName, "value" : tempObj}})
          this.props.onChange(customEvent)
        }
      }
    }
  }

  handleRecursiveChange = (event: any) => {

    const {component} = this.state

    // Elabora il campo JSON, lo setta all'oggetto padre e poi manda il padre a chi ha renderizzato il component
    if (event.type == CustomEvents.JSONObjectChanged) {
      let value = event.detail["value"]
      var name = event.detail["name"]
      let tempObj = component;
      tempObj[name] = value;

      if (this.props.onChange) {
        let customEvent = new CustomEvent(CustomEvents.JSONObjectChanged, {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(tempObj)}})
        this.props.onChange(customEvent)
      }
    }
  }

  renderJSONField = (fieldKey: string) : any => {

    const {component} = this.state
    return (
      this.isJSON(component[fieldKey]) ?  
            <Row className={themeGroup()}>
              <Col className={themeCol3()}>
                <label htmlFor={fieldKey}>{fieldKey}</label>   
              </Col>
              <Col className={themeCol9()}>
                <EsaedroJSONComponent 
                  component={component[fieldKey]} 
                  fieldName={fieldKey} 
                  canEdit={this.props.canEdit} 
                  onChange={this.handleRecursiveChange}>
                </EsaedroJSONComponent>
              </Col>
            </Row>
  
            : <Row className={themeGroup()}>
                <Col className={themeCol3()}>
                  <label htmlFor={fieldKey}>{fieldKey}</label>   
                </Col>
                <Col className={themeCol9()}>
                  <input 
                    className={themeFormInput()} 
                    type="text" 
                    name={fieldKey} 
                    disabled={!this.props.canEdit} value={component[fieldKey]} onChange={this.handleChange}/>    
                </Col>
              </Row>                        
    )
  }
  
  render() {
    const {component, componentFields} = this.state

    const content = componentFields.length > 0 ? 
                          componentFields.map( (key: string) => {
                          return this.renderJSONField(key)
                          })
                          : <Row className={themeGroup()}>
                              <Col className={themeCol9()}>
                              <label>Premi "Aggiungi" per creare i parametri</label>
                    
                              </Col>
                            </Row>

    const addFieldForm = (this.props.canEdit) ?
                                  
                                      <Fragment>
                                        <Row>
                                          <label htmlFor="addFieldLabel">Aggiungi campo:</label>
                                        </Row>
                                        <Row className={themeGroup()}>
                                          <Col className={themeCol3()}>
                                            <label htmlFor="newKeyLabel">Chiave:</label>   
                                          </Col>
                                          <Col className={themeCol9()}>
                                            <input 
                                              className={themeFormInput()} 
                                              type="text" 
                                              name={"NewKey"} 
                                              value={this.state.newKeyLabel} onChange={this.handleChange}/>    
                                          </Col>
                                        </Row>
                                        <Row className={themeGroup()}>
                                          <Col className={themeCol3()}>
                                            <label htmlFor="newKeyValueLabel">Valore:</label>   
                                          </Col>
                                          <Col className={themeCol9()}>
                                            <input 
                                              className={themeFormInput()} 
                                              type="text" 
                                              name={"NewKeyValue"} 
                                              value={this.state.newKeyValue} onChange={this.handleChange}/>    
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <Button_DevExtreme icon='add' onClick={this.addKey} />
                                          </Col>    
                                          <Col>
                                            <Button_DevExtreme icon='close' onClick={this.toggleAddField} />
                                          </Col>                                    
                                        </Row>
                                      </Fragment>
                                      : undefined

    const addFieldButton = this.state.addingField ? 
                                  undefined
                                  :  <Row>
                                      <Button_DevExtreme icon='add' onClick={this.toggleAddField} text='Aggiungi Campo'/>
                                    </Row>


    return (
      this.state.addingField  ? <Fragment>{content}{addFieldForm}</Fragment> 
                              : <Fragment>{content}{addFieldButton}</Fragment>
    )
  }
}